if (window.location.href.includes("https://nutririse.com/pages/botanical-bot-cart-helper")) {
	function reChargeProcessCart() {
		function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2] }
		do {
			token = get_cookie('cart');
		}
		while (token == undefined); var myshopify_domain = '{{ shop.permanent_domain }}'
		try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch (err) { var ga_linker = '' }
		checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=nutririse.myshopify.com" + "&cart_token=" + token + "&" + ga_linker;
		document.location.href = checkout_url;
	}

	function getParams(name) {
		if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
			return decodeURIComponent(name[1]);
	}

	const productIdsString = getParams("productIds");
	const quantitiesString = getParams("quantities");
	const isSubscriptional = getParams("subscriptional") === "true";
	const productIds = productIdsString.split("_");
	const quantities = quantitiesString.split("_");
	let items = [];

	for (let i = 0; i < productIds.length; i++) {
		items.push({
			id: productIds[i],
			quantity: quantities[i]
		})
	}

	const formData = {
		items: items
	}


	const addProducts = (formData) => {
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
			.then(response => {
				// return response.json();
				if (isSubscriptional) {
					reChargeProcessCart();
				} else {
					document.location.href = '/cart/checkout'
				}

			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}



	setTimeout(() => {
		fetch('/cart/clear.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(response => {
			addProducts(formData);
		}).catch((error) => {
			console.error('Error:', error);
		});
	}, 1000)
}